import { FormContents } from '../types/page';

export function detectSubjectOrTopic(
  formContents: FormContents,
): string | undefined {
  if (!formContents || typeof formContents !== 'object') {
    return undefined;
  }

  let topicFallback = '';

  for (const key of Object.keys(formContents)) {
    const value = formContents[key];
    if (typeof value === 'string' && value.trim()) {
      if (key === 'subject' || key.endsWith('Subject')) {
        return value;
      }
      if (!topicFallback && (key === 'topic' || key.endsWith('Topic'))) {
        topicFallback = value;
      }
    }
  }

  return topicFallback || undefined;
}
